import { render } from "./App.vue?vue&type=template&id=5e13f99e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5e13f99e&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__